import { render, staticRenderFns } from "./MediakitCollectionSchedule.vue?vue&type=template&id=0fb50c26&scoped=true&"
import script from "./MediakitCollectionSchedule.vue?vue&type=script&lang=js&"
export * from "./MediakitCollectionSchedule.vue?vue&type=script&lang=js&"
import style0 from "./MediakitCollectionSchedule.vue?vue&type=style&index=0&id=0fb50c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb50c26",
  null
  
)

export default component.exports